import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { TradingCustomerProfileItem } from '../../../../../../store/trading/types';

import { TradingListItemDesktop } from './Desktop';
import { TradingListItemMobile } from './Mobile';
import { TradingListItemTablet } from './Tablet';

export declare namespace TradingListItemTypes {
  export interface Props {
    item: TradingCustomerProfileItem;
    handleNavigate: ({
      currentSinacorAccount,
      currentIdAccount,
      currentAccountPNP,
      currentAccountBP,
    }) => void;
  }

  export interface Content {
    item: TradingCustomerProfileItem;
    handleNavigate: ({
      currentSinacorAccount,
      currentIdAccount,
      currentAccountPNP,
      currentAccountBP,
    }) => void;
  }
}

export const TradingListItem: React.FC<TradingListItemTypes.Props> = ({ item, handleNavigate }) => {
  const content = useBreakpointValue({
    base: <TradingListItemMobile item={item} handleNavigate={handleNavigate} />,
    sm: <TradingListItemTablet item={item} handleNavigate={handleNavigate} />,
    md: <TradingListItemDesktop item={item} handleNavigate={handleNavigate} />,
  });

  return content;
};
